import PropTypes from "prop-types";
import { connect } from "react-redux";
import { storesReady } from "redux-store";
import {
  fetchDeviceAction,
  currentDeviceUnloadAction,
} from "redux-store/ui-state/current-device/actions";
import { currentDeviceSelector } from "redux-store/ui-state/current-device/selectors";
import { FetchController } from "ui/fetch/fetch-controller";

function mapStateToProps(state, props) {
  const objectLoaded = storesReady(state.pages.currentDevice);

  return {
    objectLoaded,
    injectAs: "device",
    object: currentDeviceSelector(state),
    objectId: props.deviceId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchObject: (deviceId, params, options) => {
      return new Promise((resolve, reject) => {
        dispatch(
          fetchDeviceAction({
            resolve,
            reject,
            serviceArgs: {
              deviceId,
              options,
              params,
            },
          }),
        );
      });
    },
    unloadObject: () => {
      dispatch(currentDeviceUnloadAction);
    },
  };
}

const ConnectedFetchDeviceController = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FetchController);

ConnectedFetchDeviceController.propTypes = {
  deviceId: PropTypes.string.isRequired,
};

export { ConnectedFetchDeviceController };
